import { OrganizationModel } from '../models/organization.model';
import { CollectionModel } from 'src/app/organizations/models/collection.model';
import { CollectionContentModel } from '../models/collection.content.model';

export class SetOrganizations {
  static readonly type = '[Organizations] Set Organizations';
  constructor(public organizations: OrganizationModel[]) { }
}

export class SelectOrganization {
  static readonly type = '[Organizations] Select Organization';
  constructor(public organization: OrganizationModel) { }
}

export class SelectCollection {
  static readonly type = '[Organizations] Select Collection';
  constructor(public collection: CollectionModel) { }
}

export class GetCollections {
  static readonly type = '[Organizations] Get Collections';
  constructor(public organizationId: number) { }
}

export class GetCollectionsSuccess {
  static readonly type = '[Organizations] Get Collections Success';
  constructor(public collections: CollectionModel[]) { }
}

export class JoinOrganization {
  static readonly type = '[Organizations] Join Organization';
  constructor(public organization: OrganizationModel) { }
}

export class JoinOrganizationSuccess {
  static readonly type = '[Organizations] Join Organization Success';
  constructor(public organization: OrganizationModel) { }
}

export class JoinOrganizationFail {
  static readonly type = '[Organizations] Join Organization Fail';
  constructor(public organization: OrganizationModel) { }
}

export class ResetOrganizations {
  static readonly type = '[Organizations] Reset';
  constructor() { }
}
